import React, { ReactElement } from "react";
import RevenueReportList from "../../components/Finance/RevenueReport";
import Layout from "../../components/layout";

const RevenueReportPage = (): ReactElement => {
  return (
    <Layout>
      <RevenueReportList />
    </Layout>
  );
};

export default RevenueReportPage;
